import { ProjectItemTypes } from '../../types';
import { PROJECT_ITEM_TYPE } from '../../commons/constants';

export const isValidAmenity = (item: ProjectItemTypes): boolean => {
  return (
    !!(item.facilityCodes?.length || (item.image && item.description)) &&
    item.type === PROJECT_ITEM_TYPE.AMENITY
  );
};
